<div class="filter-grades" style="max-width: 1000px;">
    <h4 style="color:#003d79; font-weight:500; margin:0 0 10px 0;">Saved Search Filters</h4>
    <div>
        {#each arrFilterKeys as key}
        <Chip id="wv-chip-{key}" style="cursor:pointer; margin-right: 5px;" text={key.toUpperCase()} deleteable onDelete={deleteFilterChip} data-value={key} on:click={()=> populateSavedFilter(key)}/>
        {/each}
    </div>
    <div>
        <Segmented strong tag="p">
        {#each oFiltersObj.grade.options as option, i}
            <Button active={option.isActive} on:click={() => handleGradeFilter(option)}>{option.display}</Button>
        {/each}
        </Segmented>
    </div>
</div>
<script>
    import {
        Chip,
        Segmented,
        Button,
        f7,
        Link
    } from 'framework7-svelte';
    import { query, oFilterStore, bIsFilterStore, arrSavedFilterKeys } from '../stores.js';
    import { fRemoveValueFromArray } from '../utils';
    import { onDestroy } from 'svelte';

    $:oFiltersObj;
    $:getSavedFilterKeys($arrSavedFilterKeys);
    
    let sQuery = '';
    let ageInput;
    let oFiltersObj = '';
    let arrFilterKeys = '';

    const unsubscribe = oFilterStore.subscribe(value => {
		oFiltersObj = value;
	});

    onDestroy(unsubscribe);

    function deleteFilterChip(e) {
        const target = e.target;
        f7.dialog.confirm('Do you want to delete this search filter?', () => {
            // remove the saved filter
            const key = f7.$(target).parents('.chip').attr('data-value');
            localStorage.removeItem("wv-filter-"+key);
            const newArr = fRemoveValueFromArray($arrSavedFilterKeys, key);
            arrSavedFilterKeys.set(newArr);
        });
    }

    function getSavedFilterKeys(value) {
        // get filters saved in localStorage
        arrFilterKeys = value;
    }

    function populateSavedFilter(key) {
        // get stored filter obj
        oFiltersObj = JSON.parse(localStorage.getItem('wv-filter-' + key.toLowerCase()));
        // populate stored filter
        bIsFilterStore.set(true);
        oFilterStore.set(oFiltersObj);
    }

    function convertFiltersToQuery () {
        let str = '';
        for (let key in oFiltersObj) {
            const val = oFiltersObj[key].value;
            if (val !== null && val !== undefined) {
                str += `${key}=${oFiltersObj[key].value}&`;
            }
        }
        sQuery = str;
        query.set(sQuery);
    }

    function handleReset() {
        for (let key in oFiltersObj) {
            oFiltersObj[key].value = null;
        }
        sQuery = '';
    }

    function handleGradeFilter(optionObj) {
        oFiltersObj.grade.options.forEach(option => {
            if (option.display === optionObj.display) {
                option.isActive = true;
            } else {
                option.isActive = false;
            }
        });
        oFiltersObj.grade.values = optionObj.values;
        bIsFilterStore.set(true);
        oFilterStore.set(oFiltersObj);
    }
</script>
<style>
/* bug : long text in content */
p {
    overflow: auto;
}

:global(.block.block-strong) {
    padding-bottom: 0px;
}
.filter-grades {
    margin-bottom: 10px;
}
</style>